import * as React from 'react';
import { connect } from 'react-redux';

import Sidenote from 'components/sidenote/Sidenote';

import { getApprovalStatus } from 'utils/profile';
import { t } from 'utils/language';

import { needsActivationSelector } from 'selectors/account';

import './profile-approval-status.scss';

import type { BrandProfile, InfluencerProfile } from 'types';

type OwnProps = {
  profile: InfluencerProfile | BrandProfile,
  profileType: 'influencer' | 'brand'
};

type StateProps = {
  needsActivation?: boolean
};

type Props = OwnProps & StateProps;


const ProfileApprovalStatus: React.FunctionComponent<Props> = (
  {
    profile,
    profileType,
    needsActivation
  }: Props
) => {
  if (!profile.id) {
    return null; // profile is not created yet
  }

  const approvalStatus = getApprovalStatus(profile);
  const message = t(`profile_message_for_${profileType}_${approvalStatus || ''}`);

  if (!approvalStatus || !message) {
    return null;
  }

  return (
    <Sidenote type="info">
      <div className="profile-approval-status">
        <div>
          {message}
        </div>
        {
          needsActivation &&
            <div className="profile-approval-status__warning">
              <strong>
                {t('profile_message_needs_activation')}
              </strong>
            </div>
        }
      </div>
    </Sidenote>
  );
};

const mapPropsToState = (state): StateProps => ({
  needsActivation: needsActivationSelector(state)
});

export default connect(mapPropsToState)(ProfileApprovalStatus);
